<template>
    <div>
        <div class="container-fluid auth" id="login-user">
            <div class="row form w-100">
                <div class="col-xl-7 col-lg-5 col-md-2 col-sm-1"></div>
                <div class="col-xl-4 col-lg-6 col-md-8 col-sm-10 login-form">
                    <div class="card mt-5 mb-5 d-none d-sm-block">
                        <!-- <div class="card-header">Login</div> -->
                        <div class="card-body">
                            <h1
                                class="text-center mb-4 mt-5 header-title text-white"
                            >
                                LOGIN TO YOUR ACCOUNT
                            </h1>
                            <form @submit.prevent="loginAccount">
                                <div class="form-group row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <input
                                            id="email"
                                            type="email"
                                            class="form-control"
                                            name="email"
                                            v-bind:class="{
                                                'is-invalid': errors.email
                                            }"
                                            value=""
                                            required
                                            autofocus
                                            placeholder="E-mail Address"
                                            v-model="fields.email"
                                        />
                                        <span
                                            class="invalid-feedback"
                                            role="alert"
                                            v-if="errors.email"
                                        >
                                            <strong>{{ errors.email }}</strong>
                                        </span>
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>

                                <div class="form-group row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8">
                                        <input
                                            id="password"
                                            type="password"
                                            class="form-control"
                                            name="password"
                                            v-bind:class="{
                                                'is-invalid': errors.password
                                            }"
                                            required
                                            placeholder="Password"
                                            v-model="fields.password"
                                        />
                                        <span
                                            class="invalid-feedback"
                                            role="alert"
                                            v-if="errors.password"
                                        >
                                            <strong>{{
                                                errors.password
                                            }}</strong>
                                        </span>
                                    </div>
                                    <div class="col-md-2"></div>
                                </div>

                                <div class="form-group row mb-0 mt-3">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            type="submit"
                                            class="btn btn-primary form-control"
                                            style="
                                                border-radius: 7px !important;
                                            "
                                        >
                                            Login
                                        </button>
                                    </div>
                                    <div class="col-md-4"></div>
                                    <div class="col-md-12 text-center">
                                        <a
                                            class="btn btn-link text-center mt-3 mb-2"
                                            href="/password/reset"
                                        >
                                            Forgot Your Password?
                                        </a>

                                        <div class="row">
                                            <div class="col-2"></div>
                                            <div class="col-5 col-md-8 mb-2">
                                                <a
                                                    href="/auth/google"
                                                    class="btn btn-dark btn-block"
                                                    style="
                                                        background: #fff;
                                                        color: #000;
                                                        border-radius: 7px !important;
                                                    "
                                                    onclick="this.$gtag.event('login', { method: 'Google' });"
                                                >
                                                    <svg
                                                        version="1.1"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 512 512"
                                                        xml:space="preserve"
                                                        width="24"
                                                        style="
                                                            margin-right: 10px;
                                                        "
                                                    >
                                                        <path
                                                            style="
                                                                fill: #fbbb00;
                                                            "
                                                            d="M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256
	c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456
	C103.821,274.792,107.225,292.797,113.47,309.408z"
                                                        />
                                                        <path
                                                            style="
                                                                fill: #518ef8;
                                                            "
                                                            d="M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451
	c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535
	c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z"
                                                        />
                                                        <path
                                                            style="
                                                                fill: #28b446;
                                                            "
                                                            d="M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512
	c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771
	c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z"
                                                        />
                                                        <path
                                                            style="
                                                                fill: #f14336;
                                                            "
                                                            d="M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012
	c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0
	C318.115,0,375.068,22.126,419.404,58.936z"
                                                        />
                                                    </svg>
                                                    Login with Google</a
                                                >
                                            </div>
                                            <div class="col-2"></div>
                                            <div class="col-2"></div>
                                            <div class="col-5 col-md-8 mb-3">
                                                <a
                                                    href="/auth/facebook"
                                                    class="btn btn-dark btn-block"
                                                    style="
                                                        background: #fff;
                                                        color: #000;
                                                        border-radius: 7px !important;
                                                    "
                                                    onclick="this.$gtag.event('login', { method: 'Facebook' });"
                                                >
                                                    <svg
                                                        height="24"
                                                        width="24"
                                                        viewBox="0 0 512 512"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        style="
                                                            margin-right: 10px;
                                                        "
                                                    >
                                                        <path
                                                            d="m483.738281 0h-455.5c-15.597656.0078125-28.24218725 12.660156-28.238281 28.261719v455.5c.0078125 15.597656 12.660156 28.242187 28.261719 28.238281h455.476562c15.605469.003906 28.257813-12.644531 28.261719-28.25 0-.003906 0-.007812 0-.011719v-455.5c-.007812-15.597656-12.660156-28.24218725-28.261719-28.238281zm0 0"
                                                            fill="#4267b2"
                                                        />
                                                        <path
                                                            d="m353.5 512v-198h66.75l10-77.5h-76.75v-49.359375c0-22.386719 6.214844-37.640625 38.316406-37.640625h40.683594v-69.128906c-7.078125-.941406-31.363281-3.046875-59.621094-3.046875-59 0-99.378906 36-99.378906 102.140625v57.035156h-66.5v77.5h66.5v198zm0 0"
                                                            fill="#fff"
                                                        />
                                                    </svg>
                                                    <span
                                                        >Login with
                                                        Facebook</span
                                                    ></a
                                                >
                                            </div>
                                            <div class="col-2"></div>
                                        </div>

                                        <p>OR</p>
                                        <a
                                            style="
                                                        border-radius: 7px !important;
                                        "
                                            class="btn btn-primary px-4"
                                            href="/create-account-observer"
                                            data-adopte-target="#adopte-all"
                                            onclick="event.preventDefault();$('#popupSubscription').modal('show')"
                                            >SIGN UP</a
                                        >
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1"></div>
            </div>
        </div>
        <div class="card-body d-block d-sm-none">
            <h1 class="text-center mb-4 mt-5 header-title">
                LOGIN TO YOUR ACCOUNT
            </h1>
            <form @submit.prevent="loginAccount">
                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input
                            id="email"
                            type="email"
                            class="form-control"
                            name="email"
                            v-bind:class="{ 'is-invalid': errors.email }"
                            value=""
                            required
                            autofocus
                            placeholder="E-mail Address"
                            v-model="fields.email"
                        />
                        <span
                            class="invalid-feedback"
                            role="alert"
                            v-if="errors.email"
                        >
                            <strong>{{ errors.email }}</strong>
                        </span>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group row">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <input
                            id="password"
                            type="password"
                            class="form-control"
                            name="password"
                            v-bind:class="{ 'is-invalid': errors.password }"
                            required
                            placeholder="Password"
                            v-model="fields.password"
                        />
                        <span
                            class="invalid-feedback"
                            role="alert"
                            v-if="errors.password"
                        >
                            <strong>{{ errors.password }}</strong>
                        </span>
                    </div>
                    <div class="col-md-2"></div>
                </div>

                <div class="form-group row mb-0 mt-3">
                    <div class="col-md-4"></div>
                    <div class="col-md-4">
                        <button
                            type="submit"
                            class="btn btn-primary form-control"
                        >
                            Login
                        </button>
                    </div>
                    <div class="col-md-4"></div>
                    <div class="col-md-12 text-center">
                        <a
                            class="btn btn-link text-center mt-3 mb-2"
                            href="/password/reset"
                        >
                            Forgot Your Password?
                        </a>

                        <div class="row">
                            <div class="col-2"></div>
                            <div class="col-md-4 mb-2">
                                <a
                                    href="/auth/google"
                                    class="btn btn-dark btn-block"
                                    style="background: #fff; color: #000"
                                    onclick="this.$gtag.event('login', { method: 'Google' });"
                                >
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 512 512"
                                        xml:space="preserve"
                                        width="24"
                                        style="margin-right: 10px"
                                    >
                                        <path
                                            style="fill: #fbbb00"
                                            d="M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256
        c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456
        C103.821,274.792,107.225,292.797,113.47,309.408z"
                                        />
                                        <path
                                            style="fill: #518ef8"
                                            d="M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451
        c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535
        c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z"
                                        />
                                        <path
                                            style="fill: #28b446"
                                            d="M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512
        c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771
        c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z"
                                        />
                                        <path
                                            style="fill: #f14336"
                                            d="M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012
        c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0
        C318.115,0,375.068,22.126,419.404,58.936z"
                                        />
                                    </svg>
                                    Login with Google</a
                                >
                            </div>
                            <div class="col-md-4 mb-2">
                                <a
                                    href="/auth/facebook"
                                    class="btn btn-dark btn-block"
                                    style="background: #fff; color: #000"
                                    onclick="this.$gtag.event('login', { method: 'Facebook' });"
                                >
                                    <svg
                                        height="24"
                                        width="24"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                        style="margin-right: 10px"
                                    >
                                        <path
                                            d="m483.738281 0h-455.5c-15.597656.0078125-28.24218725 12.660156-28.238281 28.261719v455.5c.0078125 15.597656 12.660156 28.242187 28.261719 28.238281h455.476562c15.605469.003906 28.257813-12.644531 28.261719-28.25 0-.003906 0-.007812 0-.011719v-455.5c-.007812-15.597656-12.660156-28.24218725-28.261719-28.238281zm0 0"
                                            fill="#4267b2"
                                        />
                                        <path
                                            d="m353.5 512v-198h66.75l10-77.5h-76.75v-49.359375c0-22.386719 6.214844-37.640625 38.316406-37.640625h40.683594v-69.128906c-7.078125-.941406-31.363281-3.046875-59.621094-3.046875-59 0-99.378906 36-99.378906 102.140625v57.035156h-66.5v77.5h66.5v198zm0 0"
                                            fill="#fff"
                                        />
                                    </svg>
                                    <span>Login with Facebook</span></a
                                >
                            </div>
                            <div class="col-2"></div>
                        </div>

                        <p>OR</p>
                        <a
                            class="btn btn-primary px-4"
                            href="/create-account-observer"
                            data-adopte-target="#adopte-all"
                            onclick="$('#popupSubscription').modal('show')"
                            >SIGN UP</a
                        >
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ["token"],
    data() {
        return {
            fields: {
                email: "",
                password: "",
                _token: this.token
            },
            errors: {
                email: "",
                password: ""
            }
        };
    },
    created() {},
    methods: {
        loginAccount() {
            this.$gtag.event("login", { method: "Form" });
            fetch("/login", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => {
                    if (res.status == 200) {
                        window.location.reload();
                    } else {
                        return res.json();
                    }
                })
                .then(data => {
                    if (typeof data != "undefined") {
                        if (typeof data.errors != "undefined") {
                            this.errors.email =
                                typeof data.errors.email != "undefined"
                                    ? data.errors.email[0]
                                    : "";
                            this.errors.password =
                                typeof data.errors.password != "undefined"
                                    ? data.errors.password[0]
                                    : "";
                        }
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped>
#login-user {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom;
    background-image: url("/images/pages/auth/Login_WildlifeProtector.jpg");
    color: white;
}
#login-user .form {
    min-height: 100vh;
}
#login-user .login-form {
    display: flex;
    justify-content: center;
    align-items: center;
}
#login-user .card {
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
}
.header-title {
    font-family: "WWF";
    font-size: 3em;
}
#login-user .btn-primary {
    background-color: #f58220;
    border: none;
    font-size: 1.5rem;
    border-radius: 0px !important;
    font-family: "WWF";
    text-transform: uppercase;
}
#login-user a {
    color: white;
}

@media only screen and (max-width: 575px) {
    #login-user {
        min-height: 30vh;
    }
    #login-user .form {
        min-height: 30vh;
    }
}
@media only screen and (max-width: 768px) {
    .header-title[data-v-06688fcd] {
        font-size: 2rem;
        margin-top: 1rem !important;
    }
    .btn-primary {
        background-color: #f07d00;
        border-color: #f07d00;
    }
    .btn-primary:not(:disabled):not(.disabled):active,
    .btn-primary:not(:disabled):not(.disabled).active,
    .show > .btn-primary.dropdown-toggle {
        background-color: #d06d01;
        border-color: #d06d01;
    }
}
</style>
